import {Component, OnInit} from '@angular/core';
import {Constants} from '../Services/Constants';
import {HTTPService} from '../Services/http.service';
import {Observable}   from 'rxjs/Observable';
import {filter} from '../App/search.pipe';
import {DatePipe} from "@angular/common";
import {MySharedService} from '../App/shared.service'

declare function ExportToExcel(item: any[], workSheetName: string, keys: any,Columns?: any): void;

@Component({
    templateUrl: './AppViews/ProjectFinancial/projectFinancial.html'  
})

export class ProjectFinancialComponent implements OnInit {
    constants:Constants;
    projectFinancialItems:any=[];
    teamItems:any[];
    projectTypeItems:any=[];   
    userDetail: any;
    selfuser:boolean=true;
    filter:any={'TeamId':"",'TypeId':"",'Year':moment().format('YYYY')};
        public showLoader = false;
    Search:any;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService,private _datepipe: DatePipe){
        this.constants = new Constants();
         this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
         //this.filter.TeamId = this.userDetail.TeamID;
    }

     ngOnInit(){
         this.BindFilters();        
      this.GetProjectFinancial(true);
     }

    GetProjectFinancial(flag:boolean){
         this.selfuser=flag;
         var TeamId = 0;
         if(this.filter.TeamId == "")
         {
             TeamId = this.userDetail.TeamID;
         }
         else
         {
             TeamId = this.filter.TeamId;
         }
         this.showLoader=true;
	 
            this._httpService.ajaxPost("ProjectFinancial/GetProjectFinancial",
            {"Project_Id":0,"Team_Id":TeamId,"Project_Type":this.filter.TypeId,"ProjectYear":this.filter.Year,"User_Id":this.userDetail.SiteUserId}).subscribe(
                data =>{
                    this.projectFinancialItems=data["ProjectFinancialList"];
                },
                err => {
                    console.log("GetProjectFinancial Failed");
                     this.showLoader=false;
                     
                     this._sharedService.ShowMessage(this.constants.globalError);    
           
                },
                () =>{
                      console.log("GetProjectFinancial "+ this.selfuser); 
                       this.showLoader=false;
                       
                }
            );      
    }

    ngAfterViewInit() {
        
        $(".dateYear").datetimepicker({
            format: 'YYYY'
        }); 
        $(".datemonthYear").datetimepicker({
            format: 'MM/YYYY'
        });     
        $(".time").datetimepicker({
            format: 'HH:mm'
        });
        $("#show-filter").click(function(){$(".filter-form").slideToggle()});
    }
    BindFilters(){
        	 this.showLoader=true;
	 
      this._httpService.ajaxPost('Team/GetAssignedTeam', {"TeamId":this.userDetail.TeamID,"UserId":this.userDetail.SiteUserId}).subscribe(
           data =>{
             this.teamItems=data["AssignedTeam"];  
            //  this.teamItems.sort(function (a, b) { if (a.TeamName.toLowerCase() < b.TeamName.toLowerCase()) return -1; if (a.TeamName.toLowerCase() > b.TeamName.toLowerCase()) return 1; return 0; })
          },
          err => {
              console.log("BindFilters Failed");
               this.showLoader=false;
            //   this._sharedService.ShowMessage(this.constants.globalError);
           
          },
          () =>{
              this._httpService.ajaxPost('Common/GetParameter', 
              { "ParameterTypeId" : this.constants.enumParamterTypeName["ProjectType"] }).subscribe(
                    data => {
                        this.projectTypeItems = data["Parameter"];
                        this.projectTypeItems.sort(function (a, b) { if (a.ParameterDescription.toLowerCase() < b.ParameterDescription.toLowerCase()) return -1; if (a.ParameterDescription.toLowerCase() > b.ParameterDescription.toLowerCase()) return 1; return 0; })
                    },
                    err => {
                        console.log("BindFilters Failed");
                                this.showLoader=false;
                        // this._sharedService.ShowMessage(this.constants.globalError);
                
                    },
                    ()=>
                    {
                         this.showLoader=false;
                    }
                    
              );
               this.showLoader=false;
                
            }
        );
    }

    public clearFilter(){
        this.filter.TypeId = "";
      this.filter.TeamId = "";
        this.filter.Year = "";
        this.Search="";
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ProjectFinancial/projectFinancial.component.ts
 **/